import React, { useState, useEffect } from "react";
import BondSimulatorInput  from "./BondSimulatorInput";
import {getResultBonds} from "../services/SimulatorService";
import BondSimulatorResult from "./BondSimulatorResult";
import { TranslationService } from "../services/TranslationService";

import { debounce } from 'lodash'; // Import debounce from lodash

const BondsSimulator = ({resetForm, setResetForm, lang}) => {
  // Code pour le simulateur des obligations (Bonds)
  const initialFormData = {
    dateValeur: new Date().toISOString().split('T')[0],
    dateEcheance: "",
    coupon: "",
    valeurNominale : "1000000",
    montantAPlacer: "",
  };

  const initialResults = {
    interets: "",
    montantNet: "",
    tauxRendement: "",
    maturiteResiduelle: ""
  };

  const [formData, setFormData] = useState(initialFormData);
  const [results, setResults] = useState(initialResults);
  const [resetIsins, setResetIsins] = useState(false);

  useEffect(() => {
    if(resetForm){
      clearFormData();
      setResetIsins(true);
      setResetForm(false);
    }
  }, [resetForm]);

  const debouncedFetchData = debounce(async () => {
    try {
      if (!canSubmit()) {
        setResults(initialResults);
        return;
      }
      await submitForm();
    } catch (error) {
      console.error(error);
    }
  }, 300);

  useEffect(() => {
    debouncedFetchData();
    return () => debouncedFetchData.cancel();
  }, [formData]);

  const isFormValid = () => {
    const isValid = formData.dateValeur &&
    formData.dateEcheance && 
    formData.coupon && 
    formData.valeurNominale
    return isValid;
  }

  const updateFormData = (updates) => {
    setFormData(prev => ({...prev, ...updates}));
  }

  const clearFormData = () => {
    setFormData(initialFormData);
    setResults(initialResults);
  }

  const canSubmit = () => {
    return isFormValid();
  }

  const submitForm = async () => {
    const launchSimulation = async () => {
      var data = !formData.montantAPlacer ? {...formData, montantAPlacer: 0} : formData;
      let resultats = await getResultBonds(data);
      setResults(resultats);
    }

    await launchSimulation();
  }

  return (
    <div>
      <hr />
      <h5 className="text-center">{TranslationService.translate("titre_caracteristiques_bonds", lang)}</h5>
      <hr />
      <div className="row">
          <div className="col-md-8 col-12">
            <BondSimulatorInput
              formData={formData}
              updateFormData={updateFormData}
              clearFormData={clearFormData}
              resetIsins={resetIsins}
              setResetIsins={setResetIsins}
              lang={lang}/>
          </div>
          <div className="col-md-4 col-12">
            <div className="d-block d-md-none pt-4"></div>
            <BondSimulatorResult results={results} lang={lang}/>
          </div>
      </div>
    </div>
  );
};

export default BondsSimulator;

